module.exports = __webpack_public_path__ + "img/腳色介面_01-選擇3.cf2f5bc7.png";